<template>
    <v-menu offset-y>
        <template v-slot:activator="{ on }">
            <v-btn v-on="on" rounded :color="color" dark :outlined="outlined" small>
                {{ $t("button.help") }}
                <v-icon right>help</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-text class="text--primary">
                <v-btn
                    color="green"
                    outlined
                    block
                    flat
                    :href="'/guides/' + $i18n.locale + '.pdf'"
                    target="_blank"
                    >{{ $t("link.guide") }}</v-btn
                >
                <br />
                <v-chip color="green" class="chip-status mr-1 mb-1 mt-1" text-color="white">{{
                    $t("status.armed")
                }}</v-chip>
                {{ $t("hint.trap_armed") }}
                <hr class="mt-1 mb-1" />
                <v-chip color="orange" class="chip-status mr-1 mb-1 mt-1" text-color="white"
                    >{{ $t("status.triggered") }} 1/2</v-chip
                >
                {{ $t("hint.trap_half_triggered") }}
                <hr class="mt-1 mb-1" />
                <v-chip color="red" class="chip-status mr-1 mb-1 mt-1" text-color="white"
                    >{{ $t("status.triggered") }} 2/2</v-chip
                >
                {{ $t("hint.trap_all_triggered") }}
                <hr class="mt-1 mb-1" />
                <v-chip class="chip-status mr-1 mb-1 mt-1" outlined>{{ $t("status.no") }}</v-chip>
                {{ $t("hint.trap_no_status") }}
                <hr class="mt-1 mb-1" />
                <v-chip class="chip-status mr-1 mb-1 mt-1" outlined>
                    <v-avatar> <v-icon>signal_cellular_alt</v-icon> </v-avatar>60%
                </v-chip>
                {{ $t("hint.signal") }}
                <hr class="mt-1 mb-1" />
                <v-chip class="chip-status mr-1 mb-1 mt-1" outlined>
                    <v-avatar> <v-icon>battery_full</v-icon> </v-avatar>60%
                </v-chip>
                {{ $t("hint.battery") }}
                <hr class="mt-1 mb-1" />
                <v-chip color="red" text-color="white" class="mr-1 mb-1 mt-1">
                    <v-avatar style="margin-left:-5px">
                        <v-icon>warning</v-icon>
                    </v-avatar>
                    {{ $t("status.alert.no_status_last_24h") }}
                </v-chip>
                {{ $t("hint.no_status_last_24h") }}
                <hr class="mt-1 mb-1" />

                <v-icon color="primary" class="mr-1 mb-1 mt-1">message</v-icon>
                {{ $t("hint.has_been_notified") }}
            </v-card-text>
        </v-card>
    </v-menu>
</template>
<script>
export default {
    props: {
        color: { type: String, default: "primary" },
        outlined: { type: Boolean, default: true },
    },
}
</script>
